module.exports = "<div class=\"price\" ng-class=\"::$ctrl.priceClassModifier\">\r\n    <span class=\"price-symbol\">{{ ::$ctrl.currencySymbol }}</span>\r\n    <span class=\"price-dollars\">{{ $ctrl.priceDollar }}</span>\r\n    <div class=\"price-centsPer\">\r\n        <span class=\"sr-only\">.</span>\r\n        <span class=\"price-cents\">{{ $ctrl.priceCents }}</span>\r\n        <span ng-if=\"$ctrl.per\" class=\"price-per\">{{ $ctrl.per }}</span>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/price/price.component.html
// module id = 222
// module chunks = 0 2